import { useEffect, useState } from "react";
import { AircraftTypeDetailsSnap } from "./AircraftTypeDetailsSnap";
import { AircraftTypeDetailsNormal } from "./AircraftTypeDetailsNormal";
import { Grid } from "antd";
const { useBreakpoint } = Grid;
import { isApplySnap } from "@/utils";

export const AIRCRAFT_RANGE_STEP = {
	FIRST: "FIRST",
	SECOND: "SECOND",
};

export function AircraftTypeDetailsWrapper({ aircraftType = {} }) {
	const screens = useBreakpoint();
	const [applySnap, setApplySnap] = useState(false);

	useEffect(() => {
		setApplySnap(isApplySnap());
		function orientationChanged() {
			const timeout = 120;
			return new window.Promise(function (resolve) {
				const go = (i, height0) => {
					window.innerHeight != height0 || i >= timeout
						? resolve()
						: window.requestAnimationFrame(() => go(i + 1, height0));
				};
				go(0, window.innerHeight);
			});
		}
		window.addEventListener("orientationchange", function () {
			orientationChanged().then(function () {
				// Profit
				setApplySnap(isApplySnap());
			});
		});
		return () => {
			window.removeEventListener("orientationchange", function () {
				orientationChanged().then(function () {
					// Profit
					setApplySnap(isApplySnap());
				});
			});
		};
	}, []);

	return (
		<>
			{applySnap ? (
				<>
					<AircraftTypeDetailsSnap aircraftType={aircraftType} />
				</>
			) : (
				<AircraftTypeDetailsNormal aircraftType={aircraftType} />
			)}
		</>
	);
}
